// extracted by mini-css-extract-plugin
export default {"authorityIcon":"authorityIcon---iF53d"};